import { useQuery } from "@tanstack/react-query";
import { wars } from "@client/lib/api";
import { getE2EDashboardData, isE2EDashboardState } from "@client/lib/e2e";

export function useActiveWars(enabled = true) {
  const isE2E = isE2EDashboardState();
  return useQuery({
    queryKey: ["active-wars", isE2E ? "e2e" : "live"],
    queryFn: async () => {
      if (isE2E) {
        return getE2EDashboardData().wars;
      }
      const res = await wars.active();
      return res.data;
    },
    enabled,
    refetchInterval: isE2E ? false : 15_000, // WebSocket handles real-time; polling is fallback
    retry: isE2E ? false : 3,
    staleTime: isE2E ? Infinity : 0,
  });
}

export function useWarFeed(page = 1) {
  const isE2E = isE2EDashboardState();
  return useQuery({
    queryKey: ["war-feed", page, isE2E ? "e2e" : "live"],
    queryFn: async () => {
      if (isE2E) {
        return { data: getE2EDashboardData().warFeed, hasMore: false };
      }
      const res = await wars.feed(page);
      return res;
    },
    refetchInterval: isE2E ? false : 15_000,
    retry: isE2E ? false : 3,
    staleTime: isE2E ? Infinity : 0,
  });
}

export function useWar(id: number | null) {
  return useQuery({
    queryKey: ["war", id],
    queryFn: async () => {
      if (!id) return null;
      const res = await wars.get(id);
      return res.data;
    },
    enabled: !!id,
    refetchInterval: 10_000, // WebSocket handles real-time; polling is fallback
  });
}
